import type { ComponentTheme } from '../types/component-theme';

const lightActionStyles =
    'font-(family-name:--primary-font) relative inline-flex items-center gap-[0.45rem] whitespace-nowrap ' +
    'rounded-[62.438rem] border-[0.094rem] border-solid border-(--slate-alpha-18) bg-(--slate-alpha-12) ' +
    'px-[1.2rem] py-[0.6rem] text-[0.82rem] font-semibold text-(--text-dark) [backdrop-filter:blur(0.5rem)] ' +
    'transition-[background,border-color,transform,color] duration-200 before:-bottom-0.5! ' +
    'enabled:hover:border-(--slate-alpha-35) enabled:hover:bg-(--glass-chip-border) ' +
    'enabled:active:transform-[translateY(0.031rem)_scale(0.97)] disabled:cursor-not-allowed ' +
    'disabled:opacity-[0.4]';
const joinedLightActionStyles =
    lightActionStyles +
    ' overflow-hidden rounded-r-none! border-r-0! before:[clip-path:inset(0)]! ' +
    'enabled:hover:before:[clip-path:inset(0)]!';
const darkActionStyles =
    'font-(family-name:--primary-font) relative inline-flex items-center gap-2 whitespace-nowrap ' +
    'rounded-[62.438rem] border-[0.063rem] border-solid border-(--white-alpha-12) bg-(image:--accent-gradient) ' +
    'px-6 py-[0.6rem] text-[0.85rem] font-bold tracking-[0.01em] text-(--pure-white) ' +
    'transition-[background,border-color,transform,color] duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)] ' +
    'enabled:hover:border-(--white-alpha-18) enabled:hover:bg-(image:--accent-gradient-hover) ' +
    'enabled:hover:text-(--pure-white) enabled:active:transform-[translateY(0.063rem)_scale(0.97)] ' +
    'disabled:cursor-not-allowed disabled:opacity-[0.45] disabled:filter-[grayscale(0.3)]';
const joinedDarkActionStyles =
    darkActionStyles +
    ' z-1 -ml-0.5 rounded-l-none! border-l-0! [clip-path:inset(-1rem_-1rem_-1rem_0)] ' +
    'before:[clip-path:inset(0)]! before:shadow-(--workflow-primary-action-inset-shadow)! ' +
    'enabled:hover:before:[clip-path:inset(0)]! ' +
    'enabled:hover:before:shadow-(--workflow-primary-action-hover-inset-shadow)!';

export default {
    slots: {
        root: 'flex items-stretch',
        actionGroup: 'flex shrink-0 items-stretch',
        back: '',
        secondary: joinedLightActionStyles,
        next: '',
        icon: 'shrink-0'
    },
    variants: {
        compact: {
            true: {
                root: 'shrink-0',
                back: joinedLightActionStyles,
                next: joinedDarkActionStyles
            },
            false: {
                root:
                    'justify-end gap-2 rounded-b-[1.875rem] border-x-[0.094rem] border-b-[0.094rem] ' +
                    'border-x-(--white-alpha-18) border-b-(--white-alpha-18) bg-(--glass-surface-bg-45) px-5 py-3 ' +
                    'shadow-(--workflow-panel-actions-shadow) [backdrop-filter:blur(1rem)_saturate(2.4)]',
                back: lightActionStyles
            }
        },
        secondary: {
            true: {
                root: 'flex-wrap'
            }
        },
        loading: {
            true: {
                back: 'disabled:hover:opacity-60',
                secondary: 'disabled:hover:opacity-60',
                next: 'disabled:hover:opacity-60'
            }
        }
    },
    compoundVariants: [
        {
            compact: false,
            secondary: true,
            class: { next: joinedDarkActionStyles }
        },
        {
            compact: false,
            secondary: false,
            class: { next: darkActionStyles }
        }
    ]
} satisfies ComponentTheme;
